import isUndefined from 'lodash/isUndefined';
import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {Provider} from 'react-redux';
import {window} from 'ssr-window';
import Arg from '@spothero/arg';
import WithConfig from 'config/WithConfig';
import createStore from 'store/store';
import SearchUtils from 'search/search-utils';
import ExperimentUtils from 'utils/experiment';
import SearchRequestUtils from 'search-request/search-request-utils';
import {initialState as checkoutInitialState} from 'checkout/checkout-reducer';
import {initialState as searchRequestInitialState} from 'search-request/search-request-reducer';
import {initialState as userInitialState} from 'user/user-reducer';
import App from './App';
import GDPRModal from 'common/gdpr/GDPRModal';

class RouteProvider extends Component {
    static propTypes = {
        pageInitData: PropTypes.shape({
            userData: PropTypes.object,
            cleanedParams: PropTypes.object,
            setupData: PropTypes.object
        }).isRequired,
        isMobile: PropTypes.bool.isRequired,
        cloudfrontViewerCountryCode: PropTypes.string
    };

    constructor(props) {
        super(props);

        const {
            previous_rental: previousRental,
            promo,
            utm_source: utmSource,
            rid,
            rebook_reservation_id: rebookReservationId
        } = Arg.parse(window.location.search);
        const {
            pageInitData: {
                userData,
                cleanedParams,
                setupData
            },
            cloudfrontViewerCountryCode
        } = props;
        const {
            page_info: {
                page_type: pageType,
                setup
            },
            sid
        } = cleanedParams;
        const isCheckout = (pageType === 'checkout');
        const isSpotDetail = (pageType === 'facility');
        let showGDPRModal = false;
        let userCountryCode = null;

        this._isInitialLoadAtSearch = (pageType === 'search' || pageType === 'city' || pageType === 'destination' || pageType === 'event');

        if (userData) {
            // if a logged in user was detected on startup, save their data in the store
            setupData.user = {
                ...userInitialState,
                data: userData,
            };
        }

        // TODO: Remove this once checkout and airport spot details run off of new route setup completely since spotId is in the route
        if (isCheckout || isSpotDetail) {
            // on checkout and airport spot detail there will be a facility in the response, pull it so proper data/rates load when the respective component renders
            setupData.spot = {
                selected: {
                    spotId: setup.facility.id
                }
            };
        }

        this._initialState = {
            ...setupData,
            checkout: {
                ...checkoutInitialState,
                smsParkingPass: false,
                rid: (!isUndefined(rid)) ? parseInt(rid, 10) : checkoutInitialState.rid,
                previousRental: (!isUndefined(previousRental)),
                isRebookingReservation: (!isUndefined(rebookReservationId)) ? true : checkoutInitialState.isRebookingReservation,
                incomingPromoCode: (!isUndefined(promo)) ? promo : checkoutInitialState.incomingPromoCode,
                referralSource: (!isUndefined(utmSource)) ? utmSource : checkoutInitialState.referralSource
            }
        };

        if (this._isInitialLoadAtSearch || isCheckout || isSpotDetail) {
            this._initialState.searchRequest = {
                ...SearchRequestUtils.sanitizeSearchRequestResponse({
                    state: searchRequestInitialState,
                    response: cleanedParams
                }),
                isRouteLoading: false
            };
        }

        // this needs to run after the above because it uses parts of all of those items in determining its data
        this._initialState.search = SearchUtils.prepareStoreData({
            initData: this._initialState,
            experimentUtils: ExperimentUtils,
            pageType
        });

        if (sid) {
            this._initialState.search.data.sid = parseInt(sid, 10);
        }

        if (cloudfrontViewerCountryCode && cloudfrontViewerCountryCode !== 'US' && cloudfrontViewerCountryCode !== 'CA') {
            showGDPRModal = true;
            userCountryCode = cloudfrontViewerCountryCode;
        }

        this.state = {
            showGDPRModal,
            userCountryCode
        };

        if (this._isInitialLoadAtSearch || isCheckout) {
            window.history.replaceState(
                null,
                document.title,
                cleanedParams.search_url
            );
        }
    }

    _onGDPRModalHidden = () => {
        this.setState({
            showGDPRModal: false
        });
    }

    render() {
        const {
            isMobile
        } = this.props;
        const {
            showGDPRModal,
            userCountryCode
        } = this.state;

        return (
            <Provider store={createStore(this._initialState)}>
                <Fragment>
                    <App isMobile={isMobile} />
                    {showGDPRModal &&
                        <GDPRModal
                            onHidden={this._onGDPRModalHidden}
                            countryCode={userCountryCode}
                        />
                    }
                </Fragment>
            </Provider>
        );
    }
}

export default WithConfig(RouteProvider);
